import { render, staticRenderFns } from "./CandidateInfo.vue?vue&type=template&id=64d32648&scoped=true"
import script from "./CandidateInfo.vue?vue&type=script&lang=js"
export * from "./CandidateInfo.vue?vue&type=script&lang=js"
import style0 from "./CandidateInfo.vue?vue&type=style&index=0&id=64d32648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d32648",
  null
  
)

export default component.exports